module.exports = __webpack_public_path__ + "img/guaguaka-weigua.898d3516.png";